module.exports = __webpack_public_path__ + "media/baseattack.d80d6eee.mp4";